export enum SystemMessageActions {
    UPSERT_SYSTEM_MESSAGE = "UPSERT_SYSTEM_MESSAGE",
    REMOVE_SYSTEM_MESSAGE = "REMOVE_SYSTEM_MESSAGE"
}